export const useUserWebsitesStore = () => {
	const { data, status, error, refresh } = useLazyFetch('/api/data/user/website', {
		key: 'user-websites'
	});

	return {
		data,
		status,
		error,
		refresh
	};
};
